import React, { useState } from "react";
// import { Button } from "../form";
import { Input, Button } from "components/form";
import { toastMessage } from "utils/toastMessageHelper";
import { removeErrorFields, validateInput } from "validation";
import { survey } from "validation/schema/survey";
import commonMessages from "constant/commonMessage";
import { surveyFormValue } from "constant/staticData";
import { useTranslation } from "react-i18next";

const { BLOCK_TITLE_ALREADY_ADDED, SURVEY_BLOCK_MORE_THAN_LIMIT } =
  commonMessages;

const AddNewBlock = ({
  setTitle,
  closeModal,
  blockArray,
  setBlockArray,
  setSelectedBlock,
  setSurveyQuestionArray,
}) => {
  // Set  all value

  const [inputData, setInputData] = useState({ blockName: "" });
  const [error, setError] = useState("");
  const { t } = useTranslation();

  // function handler

  //   Validation Hanlder

  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "addNewSuveyBlockSchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  // close Model Handler
  const closeModelHandler = () => {
    setInputData("");
    closeModal();
  };

  // Add new block handler

  const addNewBlockHandler = () => {
    if (validation()) {
      const updatedError = removeErrorFields(error, "blockName");
      setError(updatedError);

      // Check if blockArray length is greater than or equal to 5
      if (blockArray.length >= surveyFormValue?.SURVEY_BLOCK_LIMIT) {
        toastMessage(SURVEY_BLOCK_MORE_THAN_LIMIT, "warning", "add-new-block");
        return;
      }

      // if (blockArray.includes(inputData?.blockName.trim())) {
      //   toastMessage(BLOCK_TITLE_ALREADY_ADDED, "warning", "add-new-block");
      //   return;
      // }

      if (blockArray.some((el) => el?.name === inputData?.blockName.trim())) {
        toastMessage(BLOCK_TITLE_ALREADY_ADDED, "warning", "add-new-block");
        return;
      }

      setSurveyQuestionArray((prevState) => ({
        ...prevState,
        [inputData?.blockName.trim()]: [], // Initialize with an empty array or any default value
      }));

      setBlockArray([
        ...blockArray,
        {
          title: "",
          totalQuestion: 0,
          name: inputData?.blockName.trim(),
        },
      ]);
      setTitle("");
      setSelectedBlock(inputData?.blockName.trim());
      closeModelHandler();
    }
  };

  return (
    <>
      <h3>{t(`CUSTOMIZATION_QUESTION.addNewSection`)}</h3>
      <div className="form_field">
        <Input
          type={"text"}
          maxLength={15}
          label={t(`CUSTOMIZATION_QUESTION.sectionTitle`)}
          error={error?.blockName}
          placeholder={t(`CUSTOMIZATION_QUESTION.enterSectionName`)}
          value={inputData?.blockName || ""}
          onChange={(e) => setInputData({ blockName: e?.target?.value || "" })}
        />
      </div>
      <div className="button_wrap button_center">
        <Button className={"light"} onClick={addNewBlockHandler}>
          {t(`COMMON.yes`)}
        </Button>
        <Button onClick={closeModelHandler}>{t(`COMMON.no`)}</Button>
      </div>
    </>
  );
};

export default AddNewBlock;
